import { Outlet } from "react-router-dom";
import { CornerChrome } from "./CornerChrome";
import { RightCommandBar } from "@/components/command/RightCommandBar";
import { DockProvider } from "@/components/command/DockContext";
import { useAppSelector } from "@/store";
import { selectAgencyDisplayName, selectProfile } from "@/store/selectors";
import { useAuth } from "@/auth/useAuth";
import { useAdaptersBootstrap } from "@/hooks/useAdaptersBootstrap";

export function ChatLayout() {
  const agencyName = useAppSelector(selectAgencyDisplayName);
  const profile = useAppSelector(selectProfile);
  const { user } = useAuth();
  useAdaptersBootstrap();
  // `useOnboardingBootstrap` è invocato in `ProtectedRoute` perché deve
  // girare anche su `/onboarding` (che è fuori da questo layout): è lì
  // che il wizard fa il save iniziale, e senza bootstrap `activeRole`
  // non è popolato → il BE risponde 400 a `PATCH /me/onboarding`.

  const initials =
    (profile.agencyName || user?.username || user?.name || "")
      .split(/\s+/)
      .map((w) => w[0])
      .filter(Boolean)
      .slice(0, 2)
      .join("")
      .toUpperCase() || "HK";

  return (
    <DockProvider>
      <div className="relative flex h-dvh overflow-hidden bg-background">
        <CornerChrome agencyName={agencyName} userInitials={initials} />
        {/* Niente padding-right: il RightCommandBar è ora un fly-in fixed
            che vive sopra il contenuto (z-index 7200), non gli ruba spazio. */}
        <div className="flex-1 overflow-y-auto">
          <Outlet />
        </div>
        <RightCommandBar />
      </div>
    </DockProvider>
  );
}
